import { CommonModule } from "@angular/common";
import { Component, Input, ViewChild } from "@angular/core";
import { MatIconModule } from "@angular/material/icon";
import { MatTable, MatTableModule } from "@angular/material/table";
import { FamilyChangeHistory, Time } from "huddyapi";
import moment from "moment";

@Component({
  selector: 'family-history',
  templateUrl: 'family-history.html',
  styleUrls: ["./family-history.scss"],
  imports: [
    MatIconModule,
    MatTableModule,
    CommonModule 
  ],
  standalone: true
})
export class FamilyHistory  {
  columns : string[] = ['when', 'fieldname', 'patient', 'operation', 'value'];

  @Input()
  history : FamilyChangeHistory[];
  @ViewChild(MatTable) patientTable!: MatTable<FamilyChangeHistory>;

  constructor() {

  }

  getWhen(dateTimeEpochSecs : number) {
    const tm  = moment.unix(dateTimeEpochSecs);
    return tm.format("MMM D, YYYY h:m:ss a");
  }

  getPatient(history : FamilyChangeHistory) {
    if (history.patientIdentifier) {
      return history.patientIdentifier;
    }
    return 'n/a';

  }

}